export const blockIconsHouseholdKingBedNew = (
	<span className='material-symbols-outlined'>king_bed</span>
);
